import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'modules/common/utils';
import { callAction } from 'store/action';
import { globalStateSelector } from 'store/selector';
import { OnlineScreenTheme } from 'modules/theme'
import { globalAction } from '../../../store/action';

export class OnlineScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: ''
    };
    this.phoneInitiate = this.phoneInitiate.bind(this);
    this.dtmfToggle = this.dtmfToggle.bind(this);
    let _this = this;
    _this.sendCall()
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  sendCall(){
    window.addEventListener('message', receiveMessage => {
      console.log(`receiveMessage ----`,receiveMessage)
      const data = receiveMessage && receiveMessage.data ? receiveMessage.data : {};
      console.log(`data.message ----`,data.message)
      console.log(`data.number ----`,data.number)
      if( data.message === "softphoneDial" ){
        this.sendMessage('callInitiate', {
          phoneNumber: data.number
        });
      }
    });
  }
  phoneInitiate(phoneNumber) {
    const re = /^[\.0-9]*$/;
    if (!re.test(phoneNumber)) {
      Alert.error(`Please enter valid number`);
      return false;
    }
    if (phoneNumber && phoneNumber.length > 3) {
      this.setState({ phoneNumber: phoneNumber })
      this.sendMessage('callInitiate', {
        phoneNumber: phoneNumber
      });
    } else {
      Alert.error(`Please enter valid number`);
    }
  }

  dtmfToggle() {
    console.log("dtmfToggle --")
    const { dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callTab', value: "DTMF" });
  }


  render() {
    var _this = this;
    const { callList, callProcess } = this.props;
    return (
      <OnlineScreenTheme
        btnCall={'/images/icons/ic_call.svg'}
        onNumberKeyPress={event => {
          if (event.key === 'Enter') {
            this.phoneInitiate(event.target.value);
          }
        }}
        onNumberChange={event => {
          const re = /^[\.0-9]*$/;
          // console.log("onChange", event.target.value);
          // if (!re.test(event.target.value)) {
          //   console.log("onChange", event.target.value);
          //   return false;
          // }
          if (event.target.value || !re.test(event.target.value)) {
            this.setState({ phoneNumber: event.target.value })
          } else {
            this.setState({ phoneNumber: "" })
          }
        }}
        onCall={event => {
          // console.log("this.state.phoneNumber", this.state.phoneNumber);
          this.phoneInitiate(this.state.phoneNumber);
        }}
        btnKeypad={'/images/icons/ic_keypad.svg'}
        onKeypadChange={e => {
          console.log('Keypad Clicked...');
          // this.dtmfToggle();
        }}
        callList={callList}
        callProcess={(callInfo) => {
          // let callInfo = {
          //   phoneNumber: data.phoneNumber
          // }
          console.log("Call Process Data", callInfo);
          // callInfo.phoneNumber = "09890496017";
          callProcess('callInitiate', callInfo);
          // console.log("Call Process Data", data);
          // callProcess
        }}
      />
    )
  }
}

OnlineScreen.contextTypes = {
  __: PropTypes.func
};

OnlineScreen.propTypes = {
  callProcess: PropTypes.func
};
const stateToProps = state => ({
  callList: globalStateSelector.getRecentCallList(state)
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
});

export default connect(stateToProps, dispatchToProps)(OnlineScreen);


// WEBPACK FOOTER //
// src/dialpad/components/layout/OnlineScreen.js